export default __webpack_public_path__ + "static/stacked-column-be74168a29570908d849f763500f7ae2.png";